import { Injectable } from '@angular/core';
import { LoginResponse } from '../models/auth.model';


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly JWT_TOKEN = 'access_token';
  private readonly REFRESH_TOKEN = 'refresh_token';
  private readonly TOKEN_TYPE = 'token_type';
  private readonly AUTH_EXPIRY = 'auth_expiry';  
  private readonly IMPERSONATION_TOKEN = 'impersonation_token';

  
  getJwtToken() {
    // Prefer impersonation token if present (used when logged in as another user)
    const impersonationToken = sessionStorage.getItem(this.IMPERSONATION_TOKEN);
    if (impersonationToken) return impersonationToken;
    return sessionStorage.getItem(this.JWT_TOKEN) || localStorage.getItem(this.JWT_TOKEN);
  }
  getTokenType() {
    return sessionStorage.getItem(this.TOKEN_TYPE) || localStorage.getItem(this.TOKEN_TYPE);
  }
  getRefreshToken() {
    return sessionStorage.getItem(this.REFRESH_TOKEN) || localStorage.getItem(this.REFRESH_TOKEN);
  }  
  

  storeImpersonationToken(token: string) {
    sessionStorage.setItem(this.IMPERSONATION_TOKEN, token);
  }

  removeImpersonationToken() {
    sessionStorage.removeItem(this.IMPERSONATION_TOKEN);
  }

  storeTokens(tokens: LoginResponse) {
    const expiryTime: number | null = Date.now() + 30 * 24 * 60 * 60 * 1000; // 30 days(in miliSec)
    const storage = tokens.isRememberMe ? localStorage : sessionStorage;
    storage.setItem(this.JWT_TOKEN, tokens.access_token);
    storage.setItem(this.TOKEN_TYPE, tokens.token_type);
    
    if(tokens.refresh_token){
      storage.setItem(this.REFRESH_TOKEN, tokens.refresh_token);
    }
    if (tokens.isRememberMe && expiryTime) {
      storage.setItem(this.AUTH_EXPIRY, expiryTime.toString()); //or use +expiryTime
    }
  }

  removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    sessionStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.TOKEN_TYPE);
    sessionStorage.removeItem(this.TOKEN_TYPE);
    localStorage.removeItem(this.REFRESH_TOKEN);
    sessionStorage.removeItem(this.REFRESH_TOKEN);
    localStorage.removeItem(this.AUTH_EXPIRY);
    sessionStorage.removeItem(this.AUTH_EXPIRY);
    sessionStorage.removeItem(this.IMPERSONATION_TOKEN);
  }

  isLoggedIn() {
    if(this.isTokenExpired()){
      return false;
    }
    return !!this.getJwtToken();
  }

  isTokenExpired(): boolean {
    const token = this.getJwtToken();
    if (!token) return true;
  
    const expiryTime = localStorage.getItem(this.AUTH_EXPIRY);

    if (expiryTime && Date.now() > +expiryTime) {
      this.removeTokens();
      return true;
    }
  
    return false;
  }
  
}
